<template>

  <div class="contact ContactForm.vue full-container block">
    <div class="left animated slideInLeft">

      <div class="content">
        <div class="box">
          <h1>

            <logo/>
          </h1>
          <div class="text-left">
            <mapPin></mapPin>

            <div class="address">
              Rua Dona Magina Pontual, 384 <br>
              Boa Viagem - CEP: 51.021-510 - Recife - Brazil<br> <br>
             Telefone: <a style="text-decoration: underline" href="tel:8130193566">(81) 3019-3566</a> <br> <br>

              WhatsApp: <a style="text-decoration: underline" href="https://wa.me/558130193566?text=Olá, entrei em contato via boldcomunicacao.com.br">(81) 3019-3566</a>
              <img src="/static/media/ico-whatsapp.svg" alt="">
            </div>
            <!-- /.address -->
            <div class="social">
              <a class="box-social" href="https://www.facebook.com/boldcomunicacao/" target="_blank">
                <icoFace></icoFace>
                <span>Curta</span>
              </a>
              <a class="box-social" href="https://www.instagram.com/boldcomunicacao" target="_blank">
                <icoInsta></icoInsta>
                <span>Siga</span>
              </a>
              <a class="box-social" href="https://www.youtube.com/channel/UCyp4B226-dw25ROkQujTXtw" target="_blank">
                <icoYoutube></icoYoutube>
                <span>Inscreva-se</span>
              </a>
            </div>
          </div>
          <!-- /.text-left -->

        </div>
        <!-- /.box -->

      </div>
      <!-- /.content -->

    </div>
    <!-- /.left -->
    <div class="right">

      <div class="form__content">
        <form action="" @submit="submitForm">
          <div class="close-ctn">
            <div @click="goBack" class="close"></div>
          </div>
          <!-- /.close-ctn -->

          <h1 class="title-primary">Quer mandar uma mensagem breve?</h1>

          <div class="sub">
            Fique à vontade! <br>
            Caso queira um atendimento mais personalizado continue o <a @click="goToHome" href="#">fluxo do site.</a>
          </div>
          <!-- /.sub -->

          <div class="form-group fake-label">
            <input v-fakelabel @keyup="chekEmptyField" v-model="form.name" type="text" class="bold-control inverted" placeholder="nome" maxlength="50" required>
            <label>nome</label>
          </div>
          <div class="form-group fake-label">
            <input v-fakelabel pattern="[0-9]{2} [0-9]{4}.[0-9]{4}([0-9])?" @keyup="chekEmptyField" @blur="chekEmptyField" type="text" class="bold-control inverted phone" placeholder="celular" maxlength="13" required>
            <label>celular</label>
          </div>
          <div class="form-group fake-label">
            <input v-fakelabel @keyup="chekEmptyField" v-model="form.email" type="email" class="bold-control inverted" placeholder="e-mail" maxlength="50" required>
            <label>e-mail</label>
          </div>
          <div class="fake-selector" v-bind:class="{'open': select.isOpen}">
            <div class="current" @click="toggleFakeSelect">
              {{select.value}}
            </div>
            <!-- /.current -->
            <div class="escolhas animated zoomIn">
                  <span
                    @click="setSelectValue(item)"
                    v-for="item in select.choices"
                    v-bind:class="{'selected': select.value === item}"
                  >{{ item }}</span>
            </div>
            <!-- /.choices -->
          </div>
          <!-- /.fake-selector -->
          <div class="form-group fake-label textarea">
            <textarea v-fakelabel @keyup="chekEmptyField" v-model="form.message" @keydown="resizeTextarea" class="bold-control inverted" placeholder="Somos todos ouvidos..." minlength="10" maxlength="1024" required></textarea>
            <label>mensagem</label>
          </div>

          <button type="submit" class="btn btn-bold inverted btn-lg btn-padding-lg">enviar</button>
        </form>



      </div>
      <!-- /.form -->


    </div>
    <!-- /.right -->
  </div>

</template>

<script>
  import logo from '../assets/logo.svg'
  import mask from 'jquery-mask-plugin'
  import closeButton from '../../static/media/ico-close.svg'
  import mapPin from '../../static/media/ico-map.svg';
  import icoFace from '../../static/media/ico-facebook.svg';
  import icoInsta from '../../static/media/ico-instagram.svg';
  import icoYoutube from '../../static/media/ico-youtube.svg';

  export default {
    name: 'ContactForm',
    data() {
      return {
        form: {
          name: '',
          phone: '',
          email: '',
          message: '',
        },
        select: {
          isOpen: false,
          value: 'Como posso ajudar?',
          choices: [
            'Tenho uma empresa e quero melhorar meus resultados',
            'Sou um profissional/estudante e quero trabalhar na bold',
          ]
        }
      }
    },
    mounted(){
      // seta a classe do menu principal
      this.$store.commit('setMenuClass', 'hidden');

      let $this = this;
      $('.phone').mask('00 0000.00009', {
        onChange(val){
          $this.form.phone = val;
        },
      });
    },
    components:{
      logo,
      closeButton,
      mapPin,
      icoFace,
      icoInsta,
      icoYoutube
    },
    methods:{
      goToHome(){
        this.$router.push('/home');
      },
      goBack(){
        this.log('closing');
        this.$router.go(-1);
      },
      resizeTextarea(event){
        let el = event.target;
        setTimeout(function(){
          el.style.cssText = 'height:auto;';
          el.style.cssText = 'height:' + (el.scrollHeight+2) + 'px';
        },0);
      },
      toggleFakeSelect() {
        this.select.isOpen = !this.select.isOpen;
      },
      setSelectValue(val) {
        this.select.value = val;
        this.select.isOpen = false;
      },
      chekEmptyField(event){
        let el = $(event.target);
        if (el.val().length > 0){
          el.parent().addClass('white');
        }else{
          el.parent().removeClass('white');
        }
      },
      submitForm(event){
        event.preventDefault();

        let $this = this;
        event.preventDefault();
        window.scroll(0,0);

        let postData = [
          {name: 'identificador', value: 'contato_rapido'},
          {name: 'tok'+'en_rds'+'tation', value: '76d813f385092cd1'+'c7a5e954a4c73c5e'},
          {name: 'nome', value: this.form.name},
          {name: 'telefone', value: this.form.phone},
          {name: 'email', value: this.form.email},
          {name: 'como-posso-ajudar', value: this.select.value},
          {name: 'mensagem', value: this.form.message},
        ];

        $('.loading').removeClass('hideL');

        RdIntegration.post(postData, function () {
          $this.$router.push('/thanks');
        });

        return false;
      }
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue